export const chatColors = {
  backgroundlinear: {
    start: "#fdf6b4",
    end: "#fddeb4",
  },
  accent: "#EB7228",

  chatBackMine: "#FFFFFF",
  chatBackYours: "#998F85",
  text: "#524D47",
  border: "#746A60",
  mainBackground: " #F7F6F4",

  white: "#FFFFFF",
  lightGray: "#cccccc",
  moreLightGray: "#EEEEEE",
  dimgray: "#555555",
  black: "#000000",

  form: {
    background: "#eeeeee",
    focused: "#eaf1fd",
  },

  disable: "#aaaaaa",
  error: "red",
};

export const modelatorColors = {
  primary: "#44499E",
  secondary: "#20B2AA",
};

export type MonitorColorType =
  | "green"
  | "purple"
  | "sakura"
  | "tomato"
  | "crimson"
  | "lime"
  | "turquoise"
  | "sky"
  | "mikan";

export const monitorColors: { [key in MonitorColorType]: string } = {
  green: "#6AB74F",
  purple: "#B74EA0",
  sakura: "#F1686A",
  tomato: "#FF6347",
  crimson: "#DC143C",
  lime: "#32CD32",
  turquoise: "#40E0D0",
  sky: "#87CEEB",
  mikan: "#F8CB62",
};
